import { render, staticRenderFns } from "./fba-shipment-add.vue?vue&type=template&id=57674e62&scoped=true&"
import script from "./fba-shipment-add.vue?vue&type=script&lang=js&"
export * from "./fba-shipment-add.vue?vue&type=script&lang=js&"
import style0 from "./fba-shipment-add.vue?vue&type=style&index=0&id=57674e62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57674e62",
  null
  
)

export default component.exports